import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import theme from './theme';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import LaptopRepair from './pages/LaptopRepair';
import DeviceBuilding from './pages/DeviceBuilding';
import DesktopService from './pages/DesktopService';
import MobileRepair from './pages/MobileRepair';
import PartsReplacement from './pages/PartsReplacement';
import TechnicalSupport from './pages/TechnicalSupport';
import DataRecovery from './pages/DataRecovery';
import Booking from './pages/Booking';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ExpertSolutions from './pages/ExpertSolutions';
import QualityRepairs from './pages/QualityRepairs';
import SecureData from './pages/SecureData';
import NetworkInstallation from './pages/NetworkInstallation';
import NetworkSecurity from './pages/NetworkSecurity';
import WifiOptimization from './pages/WifiOptimization';
import NetworkStorage from './pages/NetworkStorage';
import Cart from './pages/Cart';
import WebsiteDevelopment from './pages/WebsiteDevelopment';
import AdminDashboard from './pages/Admin/Dashboard';
import AdminLogin from './components/Admin/AdminLogin';
import ProtectedRoute from './components/Admin/ProtectedRoute';
//import { isAdminLoggedIn } from './utils/auth';
import ThankYou from './pages/ThankYou';
import Microsoft365Cloud from './pages/Microsoft365Cloud';
import CybersecurityServices from './pages/CybersecurityServices';
import SoftwareInstallation from './pages/SoftwareInstallation';
import EndpointManagement from './pages/EndpointManagement';
import VoipSystems from './pages/VoipSystems';
import ServerAdministration from './pages/ServerAdministration';
import MacRepair from './pages/MacRepair';
import TabletRepair from './pages/TabletRepair';
import ServerRepair from './pages/ServerRepair';
import DeviceRepairPage from './pages/DeviceRepairPage';
import Pricing from './pages/Pricing';
import FAQ from './pages/FAQ';
import RepairTracker from './pages/RepairTracker';
import Blog from './pages/Blog';
import Quote from './pages/Quote';
import ProductRequest from './pages/ProductRequest';
import AcceptQuote from './pages/AcceptQuote';
import FloatingButtons from './components/FloatingButtons';
import ExitIntentPopup from './components/ExitIntentPopup';
import ScrollProgress from './components/ScrollProgress';
import PageBackground from './components/PageBackground';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CartProvider>
        <Box 
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'background.default',
          }}
        >
          <ScrollProgress />
          <PageBackground />
          <Navbar />
          <FloatingButtons />
          <ExitIntentPopup />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/laptop-repair" element={<LaptopRepair />} />
              <Route path="/device-building" element={<DeviceBuilding />} />
              <Route path="/desktop-service" element={<DesktopService />} />
              <Route path="/mobile-repair" element={<MobileRepair />} />
              <Route path="/parts-replacement" element={<PartsReplacement />} />
              <Route path="/technical-support" element={<TechnicalSupport />} />
              <Route path="/data-recovery" element={<DataRecovery />} />
              <Route path="/booking" element={<Booking />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/expert-solutions" element={<ExpertSolutions />} />
              <Route path="/quality-repairs" element={<QualityRepairs />} />
              <Route path="/secure-data" element={<SecureData />} />
              <Route path="/network-installation" element={<NetworkInstallation />} />
              <Route path="/network-security" element={<NetworkSecurity />} />
              <Route path="/wifi-optimization" element={<WifiOptimization />} />
              <Route path="/network-storage" element={<NetworkStorage />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/website-development" element={<WebsiteDevelopment />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/microsoft-365-cloud" element={<Microsoft365Cloud />} />
              <Route path="/cybersecurity" element={<CybersecurityServices />} />
              <Route path="/software-installation" element={<SoftwareInstallation />} />
              <Route path="/endpoint-management" element={<EndpointManagement />} />
              <Route path="/voip-systems" element={<VoipSystems />} />
              <Route path="/server-administration" element={<ServerAdministration />} />
              <Route path="/device-repair" element={<DeviceRepairPage />} />
              <Route path="/mac-repair" element={<MacRepair />} />
              <Route path="/tablet-repair" element={<TabletRepair />} />
              <Route path="/server-repair" element={<ServerRepair />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/track-repair" element={<RepairTracker />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/product-request" element={<ProductRequest />} />
              <Route path="/accept-quote" element={<AcceptQuote />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/dashboard/*" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
            </Routes>
          </Box>
          <Footer />
        </Box>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
